import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuAdd, MenuItem, MenuRemove } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListGroupUser } from '../../../../../../api-new/state/content'
import { IconCheck, IconGroup } from '../../../../../../shared/icon/icon'
import { PermissionUserGroupModal } from '../../../../../../shared/permission-modal/permission-user-group-modal'
import { useModalActionID } from '../../../../../../shared/component/modal-dialog'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnFormat, ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'
import { useRoleOrgGroupUser } from '../../../../../../role/hook/role-org'
import { KEEP_MEMBERSHIP_TIP, ManagedByPartnerChip, isManagedByPartner } from '../../../../../../shared/partner/partner-words'

// A membership the partner API manages (Phase E, ruling E-11) carries the
// "Managed by partner" chip; keep adds it as the organization's own (a
// person's add takes the row over), so the partner's sync never removes it.
const managedCell = cell => (isManagedByPartner(cell.data) ? <ManagedByPartnerChip /> : '')

export const UserGroupList = () => {
  const { userID } = useParamsInt()

  const apiListGroupUser = useApiListGroupUser()

  const [target, show, hide] = useModalActionID()

  const handleReady = async () => await apiListGroupUser.get(`${userID}/user`)
  const handleDestroyed = () => apiListGroupUser.init()

  const handleAddShow = () => show()
  const handleClose = () => hide()

  const handleClosed = async () => apiListGroupUser.get(`${userID}/user`)

  const handleDelete = async item => {
    await apiListGroupUser.delete(`${item.groupID}/${item.userID}`)
    await apiListGroupUser.get(`${userID}/user`)
  }

  const handleKeep = async item => {
    await apiListGroupUser.post({ groupID: item.groupID, userID: item.userID })
    await apiListGroupUser.get(`${userID}/user`)
  }

  //   const handleDeleteAll = async () => {
  //     await apiListGroupUser.delete(`user/${userID}`)
  //     await apiListGroupUser.get(`${userID}/user`)
  //   }

  const roleOrgGroupUser = useRoleOrgGroupUser()

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add group" onClick={handleAddShow} show={roleOrgGroupUser.accessCreate} />
      {/* <MenuRemove text="delete all" onClick={handleDeleteAll} show={roleOrgGroupUser.accessDelete} /> */}
    </Menu>

  return (
    <React.Fragment>
      <PermissionUserGroupModal
        target={target}
        userID={userID}
        allowAdd={roleOrgGroupUser.accessCreate}
        allowDelete={roleOrgGroupUser.accessDelete}
        onClose={handleClose}
        onClosed={handleClosed}
      />
      <BreadcrumbView Icon={IconGroup} text="groups">
        <CardFullHeightScrollY title="user groups" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListGroupUser} hideFloatingFilter onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="groupName" />
            <ColumnFormat field="managedBySystemKey" header="Partner" render={managedCell} exportValue={row => (isManagedByPartner(row) ? 'Managed by partner' : '')} fit="content" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuItem Icon={IconCheck} text="keep" title={KEEP_MEMBERSHIP_TIP} pin onClick={() => handleKeep(row)} show={roleOrgGroupUser.accessCreate && isManagedByPartner(row)} />
                  <MenuRemove onClick={() => handleDelete(row)} show={roleOrgGroupUser.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
